var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckDarkGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2929 22.2929C35.6834 21.9024 36.3166 21.9024 36.7071 22.2929C37.0676 22.6534 37.0953 23.2206 36.7903 23.6129L36.7071 23.7071L26.7071 33.7071C26.3466 34.0676 25.7794 34.0953 25.3871 33.7903L25.2929 33.7071L20.2929 28.7071C19.9024 28.3166 19.9024 27.6834 20.2929 27.2929C20.6534 26.9324 21.2206 26.9047 21.6129 27.2097L21.7071 27.2929L26 31.585L35.2929 22.2929Z",
    fill: "#052211"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckDarkGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-dark-gray.42afe331a98e69acde6b840a9675e8aa.svg";